import slugify from "slugify"

export const slugifyTags = (array: string[]) =>
  array
    .filter((t) => t.length > 0)
    .map((t) =>
      slugify(t.toLowerCase(), {
        replacement: "-",
        remove: /[/&,+()$#~%.'":*?!<>{}]/g,
        lower: true
      })
    )
